"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var eventHandlerUtils = _interopRequireWildcard(require("../../utils/eventHandlers"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.707 15.29a1 1 0 0 1-1.414 0l-4.288-4.288-4.299 4.288a1 1 0 1 1-1.412-1.415l4.3-4.29c.78-.78 2.043-.78 2.823 0l4.29 4.29a1 1 0 0 1 0 1.415z"
  }));
};
ArrowUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "toggle": "toggle_2_15r6"
}; 
require('./Toggle.css');
var Toggle = function Toggle(_ref) {
  var ariaControls = _ref.ariaControls,
    children = _ref.children,
    className = _ref.className,
    isCollapsed = _ref.isCollapsed,
    onToggle = _ref.onToggle;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "toggle",
    "aria-expanded": !isCollapsed,
    "aria-controls": ariaControls,
    role: "button",
    className: (0, _classnames.default)(className, styles.toggle),
    onClick: onToggle,
    onKeyDown: eventHandlerUtils.onEnterKey(onToggle),
    tabIndex: "0"
  }, children, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, isCollapsed ? /*#__PURE__*/_react.default.createElement(ArrowDown, null) : /*#__PURE__*/_react.default.createElement(ArrowUp, null)));
};
Toggle.propTypes = {
  ariaControls: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  isCollapsed: _propTypes.default.bool,
  onToggle: _propTypes.default.func.isRequired
};
Toggle.defaultProps = {
  isCollapsed: false
};
var _default = exports.default = Toggle;
//# sourceMappingURL=Toggle.js.map